import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Button,
  Chip,
  Divider,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import { NotificationServices } from "../../services/AllServices";
import errorHandler from "../../utils/errorHandler";
import { Loader } from "../../components/CustomLoader";
import CardLayout from "../../layouts/CardLayout";
import { Helmet } from "react-helmet-async";

export default function NotificationTemplateView() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      const res = await NotificationServices.getById({ id });
      if (res.status === 200) setData(res?.data?.data);
    } catch (err) {
      errorHandler(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;
  if (!data) return <Typography>No data found</Typography>;

  return (
    <Box>
       <Helmet>
        <title>View Sub Category</title>
      </Helmet>
      <CardLayout>
        <CardHeader title="View Notification" />
        <CardContent>

      {/* Details Card */}
      <Card sx={{ borderRadius: 3 }}>

        <CardContent sx={{ lineHeight: 1.9 }}>
          <Box mb={2}>
            <Typography variant="subtitle2" color="text.secondary">
              Name
            </Typography>
            <Typography variant="h6">{data.name}</Typography>
          </Box>

          <Divider />

          <Box my={2}>
            <Typography variant="subtitle2" color="text.secondary">
              Slug
            </Typography>
            <Typography>{data.slug}</Typography>
          </Box>

          <Divider />

          <Box my={2}>
            <Typography variant="subtitle2" color="text.secondary">
              Title
            </Typography>
            <Typography fontWeight={500}>{data.title}</Typography>
          </Box>

          <Divider />

          <Box my={2}>
            <Typography variant="subtitle2" color="text.secondary">
              Message
            </Typography>
            <Card
              elevation={0}
              sx={{
                mt: 1,
                p: 2,
                bgcolor: "grey.100",
                borderRadius: 2,
                fontSize: "15px",
              }}
            >
              {data.message}
            </Card>
          </Box>

          <Divider />

          <Box mt={2}>
            <Typography variant="subtitle2" color="text.secondary">
              Status
            </Typography>

            {data.status === 1 ? (
              <Chip
                label="Active"
                color="success"
                size="small"
                sx={{ mt: 1 }}
              />
            ) : (
              <Chip
                label="Inactive"
                color="warning"
                size="small"
                sx={{ mt: 1 }}
              />
            )}
          </Box>
        </CardContent>
      </Card>
      </CardContent>
      </CardLayout>
    </Box>
  );
}
